var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-form-group', {
    attrs: {
      "disabled": _vm.formReadonly
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "照片"
    }
  }, [_vm.invoiceLog.image ? _c('b-img', {
    attrs: {
      "src": _vm.invoiceLog.image.url,
      "fluid": "",
      "thumbnail": ""
    }
  }) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "會員"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.invoiceLog.customer.name,
      callback: function callback($$v) {
        _vm.$set(_vm.invoiceLog.customer, "name", $$v);
      },
      expression: "invoiceLog.customer.name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "類型"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.types
    },
    model: {
      value: _vm.invoiceLog.type,
      callback: function callback($$v) {
        _vm.$set(_vm.invoiceLog, "type", $$v);
      },
      expression: "invoiceLog.type"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.invoiceLog.type.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "發票字軌"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.invoiceLog.no,
      callback: function callback($$v) {
        _vm.$set(_vm.invoiceLog, "no", $$v);
      },
      expression: "invoiceLog.no"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.invoiceLog.no.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "開立時間"
    }
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh
    },
    model: {
      value: _vm.invoiceLog.issued_at,
      callback: function callback($$v) {
        _vm.$set(_vm.invoiceLog, "issued_at", $$v);
      },
      expression: "invoiceLog.issued_at"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.invoiceLog.issued_at.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _vm.showRandom ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "隨機碼"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.invoiceLog.random,
      callback: function callback($$v) {
        _vm.$set(_vm.invoiceLog, "random", $$v);
      },
      expression: "invoiceLog.random"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.invoiceLog.random.$error
    }
  }, [_vm._v("此欄位為必填")])], 1) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "狀態",
      "disabled": _vm.statusReadonly
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.statuses
    },
    model: {
      value: _vm.invoiceLog.status,
      callback: function callback($$v) {
        _vm.$set(_vm.invoiceLog, "status", $$v);
      },
      expression: "invoiceLog.status"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }